/**
 * Messages list translations
 * Includes: Empty state text, etc.
 */
export default {
  emptyNormal: 'No messages yet',
  emptyStranger: 'No stranger messages yet',
  emptyFollow: 'No followers yet'
}
